var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImgBorderIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 509,
    viewBox: "0 0 531 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.298 423.134C502.258 425.925 500.11 428.666 497.855 431.354C443.185 496.507 346.035 505.022 280.864 450.373L77.0422 279.456C11.8714 224.806 3.3591 127.686 58.0294 62.5327C71.7395 46.1936 88.1211 33.4165 106 24.3043V0C81.6749 10.5211 59.3652 26.7147 41.1719 48.3967C-21.3084 122.858 -11.58 233.852 62.9009 296.308L266.723 467.226C341.204 529.682 452.233 519.951 514.713 445.49C520.705 438.349 526.033 430.872 530.703 423.134H504.298Z",
    fill: "url(#paint0_linear_908_4502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_4502",
    x1: 263.477,
    y1: -2.86621,
    x2: 263.477,
    y2: 508.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.311698,
    stopColor: "#D0FBEF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImgBorderIc);
export default __webpack_public_path__ + "static/media/aboutImgBorder_ic.d48ede65.svg";
export { ForwardRef as ReactComponent };